import { fetchBackend } from './apiClient';

export const slackAuth = async (
  projectId: string,
  userSlackId: string,
): Promise<void> => {
  const path = `/slack/auth/${projectId}/${userSlackId}`;

  const response = await fetchBackend(path, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Error authenticating Slack user: ${response.status} err: ${response.statusText}`,
    );
  }
};

export const slackSignOut = async (): Promise<void> => {
  const path = `/slack/auth/signout`;

  const response = await fetchBackend(path, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(
      `Error signing out Slack user: ${response.status} err: ${response.statusText}`,
    );
  }
};
